/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ComputeScalingInput = {
  idleTimeoutSeconds: number;
  maxReplicas: number;
  minReplicas: number;
};

/** @internal */
export const ComputeScalingInput$inboundSchema: z.ZodType<
  ComputeScalingInput,
  z.ZodTypeDef,
  unknown
> = z.object({
  idle_timeout_seconds: z.number().int(),
  max_replicas: z.number().int(),
  min_replicas: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "idle_timeout_seconds": "idleTimeoutSeconds",
    "max_replicas": "maxReplicas",
    "min_replicas": "minReplicas",
  });
});
/** @internal */
export type ComputeScalingInput$Outbound = {
  idle_timeout_seconds: number;
  max_replicas: number;
  min_replicas: number;
};

/** @internal */
export const ComputeScalingInput$outboundSchema: z.ZodType<
  ComputeScalingInput$Outbound,
  z.ZodTypeDef,
  ComputeScalingInput
> = z.object({
  idleTimeoutSeconds: z.number().int(),
  maxReplicas: z.number().int(),
  minReplicas: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    idleTimeoutSeconds: "idle_timeout_seconds",
    maxReplicas: "max_replicas",
    minReplicas: "min_replicas",
  });
});

export function computeScalingInputToJSON(
  computeScalingInput: ComputeScalingInput,
): string {
  return JSON.stringify(
    ComputeScalingInput$outboundSchema.parse(computeScalingInput),
  );
}
export function computeScalingInputFromJSON(
  jsonString: string,
): SafeParseResult<ComputeScalingInput, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ComputeScalingInput$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ComputeScalingInput' from JSON`,
  );
}
